import { useState } from 'react';
import { MIN_ZOOM } from '../constant/constant';
import { ZoomAxis } from '../interface/interface';

const useHandleZoom = (zoom: number) => {
  const [dragging, setDragging] = useState(false);
  const [start, setStart] = useState<ZoomAxis>({ x: 0, y: 0 });
  const [position, setPosition] = useState<ZoomAxis>({ x: 0, y: 0 });

  const handleTouchStart = (e: React.TouchEvent) => {
    if (zoom === MIN_ZOOM) return;
    setDragging(true);
    setStart({
      x: e.touches[0].clientX - position.x,
      y: e.touches[0].clientY - position.y,
    });
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!dragging) return;

    const x = e.touches[0].clientX - start.x;
    const y = e.touches[0].clientY - start.y;

    setPosition({
      x: Math.max(Math.min(x, 100), -100),
      y: Math.max(Math.min(y, 100), -100),
    });
  };
  return {
    handleTouchMove,
    handleTouchStart,
    position,
    setPosition,
    setDragging,
  } as const;
};

export default useHandleZoom;
